import React from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Checkbox from "@amzn/meridian/checkbox";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import EyeToken from "@amzn/meridian-tokens/base/icon/view";
import Text from "@amzn/meridian/text";
import { Notice } from "./types";

interface NoticeTableProps {
    valueNotices: Notice[];
    queries: any[];
    selected: { [key: string]: boolean };
    onChangeRow: (id: string) => (value: boolean) => void;
    onViewPdf: (url: string) => void;
}

export const NoticeTable: React.FC<NoticeTableProps> = ({
    valueNotices,
    queries,
    selected,
    onChangeRow,
    onViewPdf,
}) => {
    return (
        <Table showDividers={true}>
            {valueNotices.map((notice, index) => {
                const queryData = queries[index]?.data;

                return (
                    <TableRow key={notice.artifactId}>
                        <TableCell>
                            <Checkbox
                                checked={selected[notice.artifactId] || false}
                                onChange={onChangeRow(notice.artifactId)}
                            />
                        </TableCell>
                        <TableCell>
                            <Text>{queryData?.artifactDetails.mailId || "N/A"}</Text>
                            <Text color="secondary">
                                {queryData?.artifactDetails.receiveDate
                                    ? new Date(
                                          queryData.artifactDetails.receiveDate
                                      ).toLocaleDateString()
                                    : "N/A"}
                            </Text>
                        </TableCell>
                        <TableCell alignmentHorizontal={"end"}>
                            <Button
                                type={"icon"}
                                onClick={() =>
                                    onViewPdf(
                                        queryData?.artifactDetails.documentS3PreSignedUrl || ""
                                    )
                                }
                                disabled={!queryData?.artifactDetails.documentS3PreSignedUrl}
                            >
                                <Icon tokens={EyeToken}></Icon>
                            </Button>
                        </TableCell>
                    </TableRow>
                );
            })}
        </Table>
    );
};
